import axios from 'axios';

async function getCompany() {
    return axios.get('/Company/GetCompany')
}

const companyService = {
    getCompany,
   
}

export default companyService;